import { getImageByContentId } from "../../scripts/images";
import { createGuid } from "../../scripts/general_functions";
import { getLangForApi } from "#scripts/cmsapi.js";
import language from "../../scripts/translation";

export const getNews = (load = 3, from = 0, callback) => {
    // fetch(window.apiUrl + `/api/PublicContentApi/getcontentlistdescending/${client.clientId}/mal_nyhet/${load}/${from}/Modified`).then(results => results.json()).then(data => {
    const defaultContentTypes = ["73da834a-d2cf-4659-ab23-760986ecbfde"];
    fetch(window.apiUrl + `/api/Public/articles?subscriptionId=${client.clientId}&language=${getLangForApi()}&ContentTypes=${defaultContentTypes.join(",")}&IncludeCategories=false&limit=${load}&offset=${from}&getRecursiveContent=true&sortBy=Modified&LanguageMode=Strict`).then(results => results.json()).then(data => {
        callback(data);
    });
}

export const newslistFront = (maxItems = 3, moduleTitle, moreText = "", cardDesign = "") => {
    let more = ``;
    let content = "";

    getNews(maxItems, 0, (data) => {
        // console.log(data);
        let news = [];

        if (data.totalCount > 0) {
            data.listOfContent.forEach((item) => {
                let image = ``;
                let hasImage = false;
                let cloudinaryUrl = "";
                let newsGuid = createGuid();
                let meta = JSON.parse(decodeURIComponent(item.metaObject));

                if (meta.imageContentId) {
                    hasImage = true;
                    image = `<div class="news__image_container"><img src='' id='news__${newsGuid}' class="news__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}"></div>`;
                    getImageByContentId(meta.imageContentId, (img) => {
                        if ($(document).width() <= 770) {
                            //Mobile view
                            cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_770,h_433,c_fill/" + img.url;
                        }
                        else {
                            //Desktop view
                            if (maxItems == 1) {
                                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_180,h_180,c_fill/" + img.url;
                            }
                            else {
                                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_360,h_200,c_fill/" + img.url;
                            }
                        }
                        $(`#news__${newsGuid}`).attr("src", cloudinaryUrl);
                    });
                }
                news.push(`
                            <div class="news__item">
                                ${image}
                                <div class="news__content">
                                    <a href="/nyhet/${item.contentId}" class="news__item__title">
                                        ${item.title}
                                        <p class="news__item__intro">${item.intro}</p>
                                    </a>
                                </div>
                            </div>`);
            })
            news = news.join("");

            // console.log(data);
            if (data.totalCount > maxItems) {
                let detfaultMoreText = language("NEWS_SEEALL") != "NEWS_SEEALL" ? language("NEWS_SEEALL") : "Se alle nyheter";
                moreText = moreText != "" ? moreText : detfaultMoreText;
                more = `<a href="/liste/nyheter" class="simple-button-plugin xnews__more__link">${moreText} <span class="material-icons-outlined news__more__icon">&#xE5C8;</span></a>`;
            }

            content = `
                <div class="container p-md-0">
                    <div class="row">
                        <div class="col"><h1 class="news__title">${moduleTitle != undefined ? moduleTitle : language("START_NEWSHEADER")}</h1></div>
                    </div>
                    <div class="news" id="news">
                        ${news}
                    </div>
                    <div class="row">
                        <div class="col text-center">
                            <div class="news__more__container">
                                ${more}
                            </div>
                        </div>
                    </div>
                </div>`;

            $("#module__newslist").html(content);
        }
    })

    return `<section id="module__newslist" class="${cardDesign}"></section>`;
}

// export const newspage = () => {
//     let list = setNewsList();
//     return `
//         <div class="newslist__page" id="newslistcontainer">
//             ${list}
//         </div>`;
// }

// export const setNewsList = (from, loadNum) => {
//     // const breadcrumbHtml = breadcrumb();
//     loadNum = loadNum || 10;
//     from = from || 0;

//     getNews(loadNum, from, function(result) {
//         let availablenews = result.totalCount;
//         let to = loadNum + from;
//         let newsList = [];

//         $.each(result.listOfContent, function(a, b) {
//             let date = new Date(b.firstCreated);
//             let pDate = ('0' + date.getDate()).slice(-2) + '-' +
//                 ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
//                 date.getFullYear();
//             // console.log("b",b);
//             let meta = JSON.parse(decodeURIComponent(b.metaObject));
//             // console.log("meta", meta);
//             let img = "";
//             let width = "col-sm-9";

//             if (meta.imageContentId !== undefined && meta.imageContentId.length > 0) {
//                 let imgId = createGuid();
//                 img = `
//                     <div class="col-sm-3 image__container">
//                         <img src="" alt="" class="article__introimage" id="${imgId}" >
//                     </div>`;

//                 //console.log('getImageByContentId: + ' + meta.imageContentId);
//                 getImageByContentId(meta.imageContentId, (img) => {
//                     if (img.url !== undefined && img.url.length > 0) {
//                         $(`#${imgId}`).attr("src", img.url);
//                     }
//                 });
//             }

//             console.log("test before push");
//             newsList.push(`
//                 <div class="newslist__item">
//                     <div class="row">
//                         <a href = "/article/${b.contentId}" class = "newslist__link" >
//                             $ { img }
//                             <div class="${width}">
//                                 <div class="newslist__content">
//                                     <h3 class="newslist__header">
//                                         ${b.title}
//                                     </h3>
//                                     <p class="newslist__intro">${b.intro}</p>
//                                     <div class="newslist__date">${pDate}</div>
//                                 </div>
//                             </div>
//                         </a>
//                     </div>
//                 </div>`);
//         });

//         // $("#currentPageBreadcrumb").text(document.title);
//         newsList = newsList.join("");

//         $(".newslist__list").append(newsList);
//         const newslist__header = `
//             <div class="row">
//                 <div class="col mt-5">
//                     <p>
//                         Viser nyhet ${(from+1)} til ${availablenews > to ? to : availablenews} av ${availablenews}
//                     </p>
//                 </div>
//             </div>`;

//         $(".newslist__info").html(newslist__header);
//         if (availablenews > loadNum) {
//             let pages = Math.ceil(availablenews / loadNum);
//             // console.log(pages);
//             let pageslinks = [];
//             let i = 0;

//             for (i = 0; i < pages; i++) {
//                 pageslinks.push(`
//                     <li class="page-item ${(i*loadNum) === from ? "disabled" : ""}"><a class="page-link news__page__links " href="#" data-from="${(i*loadNum)}" >${(i+1)}</a></li>`);
//             }

//             pageslinks = pageslinks.join("");
//             const newslist__footer = `
//                 <div class="row">
//                     <div class="col mt-5">
//                         <nav aria-label="Bla i sider">
//                           <ul class="pagination  pagination-lg">
//                             ${pageslinks}
//                           </ul>
//                         </nav>
//                     </div>
//                 </div>`;

//             $(".newslist__footer").html(newslist__footer);
//         }

//     });

//     $("body").off("click", ".news__page__links");
//     $("body").on("click", ".news__page__links", function(e) {
//         e.preventDefault();
//         const num = $(this).data("from");
//         setNewsList(parseInt(num));
//         // $(window).scrollTo(0);
//     });

//     console.log("container", $("#newslistcontainer").length);
//     const listcontainer = `
//         <div class="container">
//             <div class="row">
//                 <div class="newslist col">
//                     <h1 class="page__header">Nyheter</h1>
//                     <div class="newslist__info"></div>
//                     <div class="newslist__list"></div>
//                     <div class="newslist__footer"></div>
//                 </div>
//             </div>
//         </div>`;

//     $("#newslistcontainer").html(listcontainer);
//     return listcontainer;
// }
